 <template>
  <div class="block">
    <p v-if="showLabel" class="font-bold capitalize mb-1" style="font-size: 13px; display: flex; align-items: center;">Select Location</p>
    <el-cascader v-model="selected_locations" size="medium" style="width: 100%;" collapse-tags placeholder="Select Location"
      filterable :props="{ multiple: true, expandTrigger: 'hover' }" clearable  :options="newLocationsData"
      @change="updateValue"></el-cascader>
  </div>
</template>
<script>
// import { mapState, mapActions } from "vuex";
import { EventBus } from "../../eventBus";
// import simplebar from "simplebar-vue";
// import "simplebar/dist/simplebar.min.css";
import { serverAddr } from "../../networkConfig";
import CommonService from "../../services/commonService";
import CommonUtils from "../../utils/common.utils";
export default {
  name: "BaseLocationsDD",
  // components: {
  //   simplebar,
  // },
  props: {
    selectedLocation: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: () => "",
    },
    showLabel: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      locations: [],
      selected: [],
      selectStore: "",
      newLocation: [],
      basics: "",
      user: {},
      show_option: true,
      selected_locations: [],
      updatedLocations: [],
    };
  },
  computed: { 
    newLocationsData() {

      function capitalizeLabel(label) {
       return label[0].toUpperCase() + label.slice(1).toLowerCase();
      }

      const data = this.updatedLocations;
      // CHange key of data array regions to children
      data.map(item => {
        item.children = item.regions.filter((e)=>e.name !== 'region1');
        item.label = item.name.toLowerCase();
        item.value = item.id

        item.children.map(child => {
          child.children = child.subregions
          child.label = child.name.toLowerCase();
          child.value = child.id

          child.children.map(sub_child => {
            sub_child.children = sub_child.outlets
            sub_child.label = sub_child.name.toLowerCase();
            sub_child.value = sub_child.id

            sub_child.children.map(sub_child_two => {
              sub_child_two.label = sub_child_two.name.toLowerCase();
              sub_child_two.value = sub_child_two.id
            })

          })

        })
      }
      )

      return data;
    }

  },
  created() {
    this.createdFunctionCall();
  },
  mounted() {
    // console.log('Thisss', this.locations)
    EventBus.$on("refreshData", this.refreshDropDownData);

    EventBus.$on("clearSelctedInputs", () => {
      this.selected = [];
    });

    this.email = localStorage.getItem('user_email');
    this.checkUserAuth();

    setTimeout(() => {
      this.getLocationAsPerAccessLevel();
    }, 1000)
  },
  beforeDestroy() {
    EventBus.$off("clearSelctedInputs");
  },
  methods: {
    updateValue(event) {
      const passVal = [];

      this.selected_locations.forEach(element => {
        // pass only last element of array into passVal
        passVal.push(element.slice(-1)[0]);
      });
    
      // console.log("Last element from array",passVal)
      this.$emit("selectedLocationVal", passVal);
    },
    checkUserAuth() {
      // admin@wellnessforever.in
      if (this.email == 'tushar.shinde@wellnessforever.in' || this.email == 'gokuldas.gawade@wellnessforever.in' || this.email == 'safiahmad.khan@wellnessforever.in' || this.email == 'ratnesh.maurya@wellnessforever.in' || this.email == 'amar.soni@wellnessforever.in') {
        this.show_option = false
      } else {
        this.show_option = true
      }
    },
    getLocationAsPerAccessLevel() {
      let newLocation = [];
      serverAddr
        .get("/users/self/", {})
        .then((res) => {
          // console.log(JSON.parse(res.data));
          let user = JSON.parse(res.data);
          this.user = JSON.parse(res.data);
          if (user.access_level == "region") {
            var filteredArray = this.locations
              .filter((element) =>
                element.regions.some(
                  (regions) => regions.id === user.access_region[0]
                )
              )
              .map((element) => {
                let n = Object.assign({}, element, {
                  regions: element.regions.filter(
                    (regions) => regions.id === user.access_region[0]
                  ),
                });
                return n;
              });
            this.newLocation = filteredArray;
            // console.log("newLocation", filteredArray);
          } else if (user.access_level == "sub_region") {
            var op = this.locations.map((val) => {
              let regions = val.regions
                .filter(({ subregions }) =>
                  subregions.some(({ id }) => {
                    return id == user.access_subregion[0];
                  })
                )
                .map((subregions) => {
                  let n = Object.assign({}, subregions, {
                    subregions: subregions.subregions.filter(
                      (subregions) => subregions.id === user.access_subregion[0]
                    ),
                  });
                  return n;
                });

              val.regions = regions;
              return val;
            });
            this.newLocation = op;
            // console.log("newLocation", op);
          } else if (user.access_level == "admin") {
            this.newLocation = this.locations;
          } else {
            this.selectStore = user.access_outlet_name;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    createdFunctionCall() {
      if (this.$route.name == "forecastCategory") {
        this.getLocations({
          type: [
            "store",
            "warehouse",
            "head_office",
            "distribution_centre",
            "regional_office",
            "vendor",
          ],
        });
      } else if (this.$route.name == "forecastCentralKitchen") {
        this.getLocations({ type: ["central_kitchen"] });
      } else {
        this.getLocations();
      }
      if (this.selectedLocation.length) {
        for (let index = 0; index < this.selectedLocation.length; index++) {
          // console.log(this.selectedLocation[index]);
          this.pushToSelectedArray(this.$event, this.selectedLocation[index]);
          setTimeout(() => {
            this.newLocation.forEach((l1) => {
              if (this.selectedLocation[index].id == l1.id) {
                l1.isSelected = true;
              } else {
                l1.regions.forEach((l2) => {
                  if (this.selectedLocation[index].id == l2.id) {
                    l2.isSelected = true;
                  } else {
                    l2.subregions.forEach((l3) => {
                      if (this.selectedLocation[index].id == l3.id) {
                        l3.isSelected = true;
                      } else {
                        l3.outlets.forEach((l4) => {
                          if (this.selectedLocation[index].id == l4.id) {
                            l4.isSelected = true;
                          }
                        });
                      }
                    });
                  }
                });
              }
            });
          }, 1000);
        }
      }
    },
    refreshDropDownData() {
      console.log('refreshDropDownData');
      this.selected = [];
      this.basics = "";
      this.newLocation = [];
      this.createdFunctionCall();
      this.getLocationAsPerAccessLevel();
    },
    // ...mapActions("CommonStore", ["getLocations"]),
    pushToSelectedArray(event, selectedObj) {
      if (this.$route.name != "Category") {
        EventBus.$emit("breadCrumbs", []);
      }
      // display array is selected array.
      // push the selected obj to the display array to display the selected field,
      // and also remove the selected field from the display area.
      // and also remove the fields if basics field changes

      // console.log("selectedObj", selectedObj);
      this.basics = selectedObj.type; // set the basics so that other selected fields can be removed from display array
      selectedObj.isSelected = !selectedObj.isSelected; // toggle selected field
      if (selectedObj.isSelected) {
        this.selected.push(selectedObj); // push selected field to display array.
      } else {
        this.removeElement(selectedObj); // remove field from the display array
      }
      const duplicateloc_selected = this.selected.slice(); // duplicate the display array
      duplicateloc_selected.map((obj) => {
        // remove fields if basics field is changed
        if (obj.type != this.basics) {
          this.removeFromSelectedArray(obj, "FromPushToSelectedArray");
        }
      });
      this.$emit("update", { basics: this.basics, selected: this.selected });
      // this.$store.commit("setLocSelected", this.selected);
    },
    removeFromSelectedArray(removedObj, FromPushToSelectedArray) {
      if (this.$route.name != "Category") {
        EventBus.$emit("breadCrumbs", []);
      }
      // reomove the selected field from dipslay array.
      removedObj.isSelected = false; // make the selected field to false
      this.removeElement(removedObj, FromPushToSelectedArray); // actual removal of field
    },
    removeElement(elementToRemove, FromPushToSelectedArray) {
      // check each element in the array and remove the field.
      this.selected.forEach((obj, i, arr) => {
        if (obj.id === elementToRemove.id) {
          arr.splice(arr.indexOf(obj), 1);
        } // remove the selected value from the screen
      });
      if (!FromPushToSelectedArray) {
        this.$emit("update", { basics: this.basics, selected: this.selected });
      }
    },
    getLocations(args) {
      CommonService.getLocations(args)
        .then((response) => {
          var locations = CommonUtils.insertIsSelectedKey(
            JSON.parse(response.data).results
          );
          this.updatedLocations = JSON.parse(response.data).results;
          locations.forEach((item, index) => {
            this.$set(this.locations, index, item);
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./BaseLocationsDD.scss";
@import "../../assets/css/variable.scss";

.AppForecast {
  background-color: #fff;
}

.AppForecast .Schedule-btn {
  margin: 0 10px 12px;
  padding: 8px 12px 6px !important;
  background-color: $orange-bg-button-color;
  border: 1px solid $orange-bg-button-color;
  @extend .amp-btn;
}

.AppForecast .search-container input:focus {
  outline: none;
}

.AppForecast .second-sec {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 15px 0;
}
</style>
<style>
.AppForecast .el-input__inner {
  border-color: #c8c8c8;
  border-radius: 4px;
}

.AppForecast .el-input--suffix .el-input__inner {
  padding-right: 58px;
}

div[disabled="disabled"] {
  pointer-events: none !important;
  opacity: 0.7;
}

.scrollable-list {
  z-index: 9999;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}

span.el-cascader-node__label {
    text-transform: capitalize;
}
.el-cascader__suggestion-item>span { 
    text-transform: capitalize;
}

.el-cascader__search-input {
    text-transform: capitalize;
}
</style>
